import React from 'react'
import '../App.css';
import { Transition } from 'react-transition-group';
import StudentIDPage from './StudentIDPage';
import RegistrationIDPage from './RegistrationIDPage';

export default function StudentInformationPage({isNewstudent,setRegId,setPupulNo,studentID,registrationID, showSIPage, firstTimeInSIPage, setApplicantLastName
                                                ,setApplicantFirstName, setApplicantDOB, applicantDOB, applicantLastName, applicantFirstName}) {

    function Loadstudentidpage() {
        if(isNewstudent) {
            return (
                <RegistrationIDPage setRegId={setRegId} registrationID={registrationID} setApplicantFirstName={setApplicantFirstName} 
                setApplicantDOB={setApplicantDOB} applicantDOB={applicantDOB} applicantFirstName={applicantFirstName} 
               applicantLastName={applicantLastName} setApplicantLastName={setApplicantLastName}/>
            );
        }
        else {
            return (
                <StudentIDPage setPupulNo={setPupulNo} studentID={studentID} setApplicantFirstName={setApplicantFirstName} 
                 setApplicantDOB={setApplicantDOB} applicantDOB={applicantDOB} applicantFirstName={applicantFirstName} 
                applicantLastName={applicantLastName} setApplicantLastName={setApplicantLastName}/>           
            );
        }
    }
  
    const duration = 700;

    const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    }

    const transitionStyles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
    };

    return(
        <>
         <Transition in={showSIPage} timeout={duration} appear ={firstTimeInSIPage}>
            {state => (
            <div style={{
                ...defaultStyle,
                ...transitionStyles[state]
            }}>
                <Loadstudentidpage />
            </div>)}
            </Transition>
        </>
    );
}
